import React from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

import type { TableColumn } from '../types';

interface TableHeaderProps<T> {
  columns: TableColumn<T>[];
  enableStickyColumns?: boolean;
}

export const TableHeader = <T,>({
  columns,
  enableStickyColumns = false
}: TableHeaderProps<T>) => (
  <div className="bg-[#F5F6F7] border-b border-[#EEEFF2]">
    <div className="flex h-10">
      {columns.map(column => (
        <div
          key={column.key}
          className={`${column.width || 'flex-1'} ${
            enableStickyColumns && column.width ? 'flex-shrink-0' : ''
          } py-4 pl-4 pr-2 flex items-center gap-2 ${
            enableStickyColumns && column.sticky === 'right'
              ? 'sticky right-0 bg-[#F5F6F7] border-l border-[#EEEFF2] shadow-[-4px_0_8px_-2px_rgba(0,0,0,0.1)] z-10'
              : enableStickyColumns && column.sticky === 'left'
              ? 'sticky left-0 bg-[#F5F6F7] border-r border-[#EEEFF2] shadow-[4px_0_8px_-2px_rgba(0,0,0,0.1)] z-10'
              : ''
          }`}>
          {column.renderHeader ? (
            column.renderHeader()
          ) : (
            <Typography variant="metadata-sm-medium" color="dark">
              {column.label}
            </Typography>
          )}
        </div>
      ))}
    </div>
  </div>
);
